import i18n from "../../../constants/i18n";
import { DEVELOPER_AI_IMAGE_CHECK_HEADERS } from "../../../constants/table-custom-headers/Developers";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Table from "../../../core/et3-table";
import getDebugAIData from "../../../stores/developer-store/debug-ai-data";

const DebugImageCheckData = withLiteObserverAndTheme(() => {
  const aiImageData = getDebugAIData().imageCheckerData.get();
  return (
    <Et3Table
      columns={DEVELOPER_AI_IMAGE_CHECK_HEADERS}
      rows={aiImageData}
      title={i18n.get("DEBUG_IMAGE_AI")}
      shouldBeFlagged={false}
      titleKey={"DEBUG_IMAGE_AI"}
    />
  );
});

export default DebugImageCheckData;
